import { cx } from '../internal/tone';

export interface SpinnerProps {
  label?: string;
  className?: string;
}

/**
 * Indicador de espera. O texto é visível, não só anunciado: uma roda a girar
 * sem palavra nenhuma não diz a ninguém que o aplicativo está viva.
 */
export function Spinner({ label = 'Carregando…', className }: SpinnerProps) {
  return (
    <span className={cx('flos-spinner', className)} role="status" aria-live="polite">
      <span className="flos-spinner__ring" aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
